import { SearchField } from '@/components/Form';
import { SearchHelpIconModal } from '@/features/analyze/components/SearchHelpIconModal';
import { TranslateSearchTextControls } from '@/features/analyze/components/TranslateSearchTextControls';
import { useTranslateAndSearch } from '@/hooks/useTranslateAndSearch';

interface SearchWidgetProps {
  onSuccess: (query: string) => void;
}

export const SearchWithTranslation = ({ onSuccess }: SearchWidgetProps) => {
  const {
    isTranslateSearchEnabled,
    setIsTranslateSearchEnabled,
    translationInfo,
    errorMessage,
    handleSearch,
    inputValue,
    setInputValue,
  } = useTranslateAndSearch();

  const field = (
    <SearchField
      value={inputValue}
      onSubmit={() => {
        handleSearch(onSuccess);
      }}
      leftIcon={<SearchHelpIconModal />}
      onChange={setInputValue}
    />
  );

  const translateControl = (
    <TranslateSearchTextControls
      isEnabled={isTranslateSearchEnabled}
      onToggle={setIsTranslateSearchEnabled}
      translationInfo={translationInfo}
    />
  );

  return (
    <div className="space-y-4">
      {field}
      {translateControl}
      {errorMessage && (
        <div className="text-sm text-red-600">{errorMessage}</div>
      )}
    </div>
  );
};
